import React, { useEffect, useState, useContext, useRef } from 'react';
import moment from 'moment';
import Alert_icon from 'dedicated/components/images/alert-icon.svg';
import Button from 'b2b-ui-components-lib/lib/components/button';
import RoundLoader from 'b2b-ui-components-lib/lib/components/roundLoader';

import PurchaseDetails from './PurchaseDetails';
import LoiDetails from './LoiDetails';
import BillingDetails from './BillingDetails';
import ActionCall from './ActionCall';
import FooterComponent from './Footer';
import UploadDocModal from './UploadDocModal';
import ViewLineDetailsModal from './ViewLineDetailsModal';

import AddressProcess from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/addressProcess';
import DrawerModalComponent from 'home/view/manage-feasibility/components/organisms/drawer_modal';
import CancelOrderPopup from 'dedicated/components/cancelOrderPopup/cancelOrderPopup';
import CircuitDetail from 'home/view/manage-feasibility/components/organisms/CircuitDetail/CircuitDetail';
import SendQuotationCard from './SendQuotationCard';

import {
  createOrder,
  fetchOrder,
  fetchOrderDetails,
  submitOrderForSummary,
  updateOrderForSummary,
  generateSummaryAuthToken,
  downloadSummaryErrorSheet,
  orderBulkDownload,
  upgradeFetchCircuitDetails,
  sendQuotationAOI,
  sendPhotoLinkAOI
} from 'home/view/manage-feasibility/services';

import {
  MULTI_SITE_MODULE_ID,
  AUTH_TOKEN,
  CART_ID,
  ORDER_ID,
  FILTER_TYPES,
  SUMMARY_AUTH_TOKEN,
  SUCCESS_TOAST,
  ERROR_TOAST,
  DEFAULT_TOAST_MSG,
  FILE_UPLOAD_PAGES,
  SHORT_CB_DELAY,
  CALLBACK_DELAY,
  MULTI_SITE_TABLE_EDITED,
  NOTIFICATION_ACTION
} from 'home/view/manage-feasibility/constants';

import { MODULE_ID, SELECTED_PARTY_DATA } from 'home/common/constants/constants';

import {
  setInSessionStorage,
  getFromSessionStorage,
  findParamFromUrl,
  isAuthForDev,
  isDevEnv,
  showServiceError,
  removeLastString,
  removeUnderScoreWithSpace,
  removeAsciiCode,
  isOrderSubmittedByCustomer
} from 'common/utils/app.utils';

import {
  GENERIC_ERROR_MESSAGE,
  getProductType,
  isNLD_OR_LL,
  ORDER_TYPE,
  ROUTES,
  isBulkUpgrade,
  isVPN_OR_DI,
  isPreOrder,
  isLoiAvailable,
  isAOIOrder
} from 'common/constants/app.constants';

import { getRequestForOrderUpdate, scrollToRef, getFileName, getFileType, downloadFileURI } from 'home/view/manage-feasibility/utils';

import { AppContext } from 'App';

import './index.scss';
import { OvRejection } from './OvRejection/ovRejection';
import PlanSummaryCard from './PlanSummaryCard/planSummaryCard';
import { NOTIFICATION_MESSAGE } from '../../constants/multiSite-constants';
// import { NOTIFICATION_TYPE } from 'common/components/notification-component/notification.constant';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import {
  defaultDataPerPageOptions,
  defaultFilterOptions,
  keyForGSTFiles,
  NLD_LL_HEADER_ORDER,
  DI_VPN_HEADER_ORDER,
  AOI_1000_SITES_HEADER_ORDER,
  ILL_UPGRADE_HEADER_ORDER,
  SEARCH_OTIONS_NLD_LL,
  SEARCH_OTIONS_DI_VPN,
  SEARCH_OTIONS_ILL_UPGRADE
} from './constant';
import { getDownloadModalTextForSummary, getDownloadModalTextForUpgrade } from 'home/view/check-feasibility/comp-generator/component.generator';
import OrderContactDetails from './OrderContactDetails';
import { validateTokenForOrder } from 'common/services/http.service';
import KdmDetails from 'dedicated/components/summary/kdmDetails/kdmDetails';
import AddressDetailsAOI from 'dedicated/components/summary/addressDetailsAOI/addressDetailsAOI';
import { formElement } from 'dedicated/components/summary/summary.constant';
import { saveOrder } from 'tokenGeneration/lead.util';
import CompanyGstDocuments from 'dedicated/components/summary/companyGSTDocuments/companyGstDocuments';
import { DOC_COMPANY_GST } from 'dedicated/components/summary/companyGSTDocuments/documents/constant';
import { DOC_ARRAY_AADHAR, DOC_ARRAY_PAN } from 'dedicated/components/summary/kdmDetails/documents/constant';

function DedicatedOrderSummaryAOI(props) {
  const partyId = findParamFromUrl('partyId', false);
  const orderIdFromParam = findParamFromUrl('orderId', false);
  const isTMORedirect = findParamFromUrl('journey', false) === 'trackLead';

  const { isdedicatedJourney, history, isUnAuthJourney } = props;
  const { setActiveStep, toast, setToast, showSteps, setNotification, setIsAuthJourney } = useContext(AppContext);

  const orderTypeFromUrl = findParamFromUrl('type', false);
  const authTokenFromUrl = findParamFromUrl('auth', false);

  const [orderType, setOrderType] = useState(isUnAuthJourney && authTokenFromUrl && orderTypeFromUrl ? orderTypeFromUrl : '');
  const [orderDetail, setOrderDetail] = useState({});

  const isUpgradeJourney = () => {
    return isBulkUpgrade() || orderType === 'CHANGE_ORDER' || (orderDetail?.['orderType'] === 'PRE_ORDER' && orderDetail?.orderSubType === 'UPGRADE');
  };

  const [isOrderLoaded, setIsOrderLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isOrderConfirmation, setIsOrderConfirmation] = useState(isOrderConfirmationUrl());
  const [opacityClass, setOpacityClass] = useState('');
  const [formStatus, setFormStatus] = useState({
    purchaseDetail: true,
    loiDetail: true,
    billingDetails: false
  });
  const [formData, setFormData] = useState({
    purchaseDetail: null,
    loiDetail: null,
    billingDetails: null
  });

  const formSchema = {
    pinCode: { ...formElement },
    city: { ...formElement },
    address: { ...formElement }
  };

  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [orderConfirmationPopup, setOrderConfirmationPopup] = useState(false);
  const [hideNotificaton, setHideNotificaton] = useState(false);
  const [otpVerifyLoader, setOtpVerifyLoader] = useState(false);
  const [totalSitesProcessed, setTotalSitesProcessed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterValue, setFilterValue] = useState(defaultFilterOptions[0]);
  const [searchType, setSearchType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tableRows, setTableRows] = useState(isNLD_OR_LL() ? NLD_LL_HEADER_ORDER : isUpgradeJourney() ? ILL_UPGRADE_HEADER_ORDER : AOI_1000_SITES_HEADER_ORDER);
  const [tableColumns, setTableColumns] = useState([]);
  const [dataPerPageValue, setDataPerPageValue] = useState(defaultDataPerPageOptions[0]);
  const [dataPerPageOptions, setDataPerPageOptions] = useState(defaultDataPerPageOptions);
  const [currentPage, setCurrentPage] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false);

  const [filterApplied, setFiltersApplied] = useState(false);
  const [multiSortArr, setMultiSortArr] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editFileMeta, setEditFileMeta] = useState({});

  const [showCanceLeadPopup, setShowCancelLeadPopup] = useState(false);

  const [sezTableData, setSezTableData] = useState({});
  const [showUploadDocModal, setShowUploadDocModal] = useState(false);
  const [selectedLocId, setSelectedLocId] = useState('');
  const [showViewLineDetailsModal, setShowViewLineDetailsModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [viewLineDetailsOpeningFromDocModal, setViewLineDetailsOpeningFromDocModal] = useState(false);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(true);
  const [isGSTorLOAupdated, setIsGSTorLOAupdated] = useState(false);
  const [uploadedDocStatus, setUploadedDocStatus] = useState({});
  const [orderContactDetails, setOrderContactDetails] = useState([]);
  const [selectedContact, setSelectedContact] = useState({});
  const [circuitModalDataSet, setCircuitModalData] = useState({});
  const [showCircuitDetailModal, setShowCircuitDetailModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [customerDetail, setCustomerDetail] = useState({});
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [showAoiKycStep, setShowAoiKycStep] = useState(false);
  const [updatedEmail, setUpdatedEmail] = useState();
  const [accordionMetadataAddress, setAccordionMetadataAddress] = useState({ isValidated: orderDetail?.eligibleForBilling ? false : true });

  const [kdmAccordionValidation, setKdmAccordionValidation] = useState(false);
  const [companyGstValidation, setCompanyGstValidation] = useState(false);

  const [formAdd, setFormAdd] = useState(formSchema);

  const newBA = 'NEW_NBA';

  const totalOrderCount = useRef(0);
  const isMultiSiteTableEdited = !!getFromSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED);
  const cartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

  const checkOrderConfirmationStatus = ({ orderStatus }) => {
    const status = (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING]).includes(orderStatus) || isOrderConfirmationUrl();
    setIsOrderConfirmation(status);
  };

  const KDM_TOAST = {
    show: true,
    message: 'this is a toast msg',
    type: 'warning',
    closeToastTime: '8000',
    eventHandler: null
  };

  useEffect(() => {
    setToast(KDM_TOAST);
    showSteps(true);
    setActiveStep(3);
    disableBackButton();
    toggelToastPopup();
    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
    const orderId = getFromSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID);
    //
    if (!orderAuthToken && !orderId && !orderIdFromParam) {
      createOrderFn();
    } else if (orderAuthToken && orderId) {
      setIsAuthJourney?.(true);
      fetchOrderFn(() => {}, orderAuthToken);
      fetchSezOnlyTableData(orderAuthToken);
      // setInSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, true);
    } else if (orderIdFromParam && isTMORedirect) {
      setIsAuthJourney?.(true);
      setInSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, true);
      generateSummaryAuthTokenForTMORedirect();
    } else if (isUnAuthJourney === true && authTokenFromUrl && orderIdFromParam && orderType === ORDER_TYPE.ORDER_CONFIRMATION) {
      validateTokenForOrder(authTokenFromUrl, orderType, orderIdFromParam).then(
        (response) => {
          setInSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, authTokenFromUrl);
          fetchOrderFn(() => {}, orderAuthToken);
          fetchSezOnlyTableData(orderAuthToken);
        },
        (err) => {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
          setShowLoader(false);
          isOrderConfirmation ? history.push(ROUTES.B2B_FAILURE) : setToast(true, errorMsg, ERROR_TOAST);
          throw new Error(errorMsg);
        }
      );
    } else {
      fetchOrderFn(() => {}, orderAuthToken);
      fetchSezOnlyTableData(orderAuthToken);
    }
  }, [orderType]);

  useEffect(() => {
    const selectedKey = dataPerPageValue && dataPerPageValue.key;
    let filterParams = {};

    if (searchType && searchValue) {
      filterParams[searchType['key']] = searchValue;
    }

    if (filterValue && filterValue.displayName !== 'All') {
      filterParams[filterValue['key']] = filterValue.displayName === 'Yes' ? true : false;
    }

    if (multiSortArr.length > 0) {
      multiSortArr.forEach((item, index) => {
        filterParams[`sort[${index}].field`] = item.key;
        filterParams[`sort[${index}].ascending`] = item.value;
      });
    }

    let timeoutId;
    if (filterApplied) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fetchTableData(null, currentPage - 1, selectedKey, filterParams, []), searchType && searchValue ? CALLBACK_DELAY : 0);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataPerPageValue, currentPage, searchType, searchValue, filterValue, multiSortArr, filterApplied]);

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const generateSummaryAuthTokenForTMORedirect = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '';
      const { res, err } = await generateSummaryAuthToken(accessToken, orderIdFromParam, partyId);
      if (res) {
        const {
          headers: { authorization = '' } = {},
          data: { success = false }
        } = res;

        if (success) {
          setShowLoader(false);
          setInSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, authorization);
          setInSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID, orderIdFromParam);

          fetchOrderFn(() => {}, authorization);
          fetchSezOnlyTableData(authorization);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);

        let redirectUrl = ROUTES.ERROR_PAGE;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history.push(redirectUrl);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const createOrderFn = async () => {
    try {
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const cartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

      setShowLoader(true);
      const { res, err } = await createOrder(leadAuthToken, cartId, isdedicatedJourney, checkIfPreOrder, 'SELF_CARE');

      if (res) {
        const {
          headers: { authorization = '' } = {},
          data: { success = false, result = {} }
        } = res;

        if (success) {
          setShowLoader(false);
          const { orderId = '' } = result;

          setInSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, authorization);
          setInSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID, orderId);

          fetchOrderFn(() => {}, authorization);
          fetchSezOnlyTableData(authorization);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        showServiceError({
          show: true,
          data: errorMsg,
          redirect: false
        });
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onNotificationClose = () => {
    setNotification({});
    setHideNotificaton(true);
  };

  const handleNotficationEvent = ({ nodeInfo, event, innerText }) => {
    const { action } = nodeInfo;
    switch (action) {
      case NOTIFICATION_ACTION.ORDER_CONFIRMATION:
        fetchOrderFn(isUpgradeJourney() ? setOrderConfirmationPopup : setShowEmailPopup);
        break;
      default:
        break;
    }
  };

  const showNotification = ({ show, message }) => {
    setNotification(show, message, NOTIFICATION_TYPE.ORDER_CONFIRMATION, handleNotficationEvent, false, onNotificationClose);
  };

  const showNotificationForSentEmail = ({ orderStatus, ocLinkSentAtList }) => {
    if (orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING) {
      const email = ocLinkSentAtList?.join(', ').toString();
      const EmailSentmessage = (
        <p>
          Order confirmation link has been sent to <a href="javascript:void(0)"> {email}</a> to {NOTIFICATION_MESSAGE.CONFIRM_ORDER}
        </p>
      );
      const verifierMessage = <p>To verify the order click on {NOTIFICATION_MESSAGE.CONFIRM_ORDER}</p>;
      showNotification({ show: true, message: isOrderConfirmation && isOrderConfirmationUrl() ? verifierMessage : EmailSentmessage });
    }
  };

  const getDefaultContactList = (contactList) => {
    const orderContactList =
      contactList &&
      contactList.map((item, index) => {
        item['key'] = index;
        item['displayName'] = `${item.firstName ? item.firstName : ''} ${item.lastName ? item.lastName : ''}`;
        !item['email'] ? (item['emailEmpty'] = true) : (item['emailEmpty'] = false);
        !item['phoneNumber'] ? (item['phoneNumberEmpty'] = true) : (item['phoneNumberEmpty'] = false);
        return item;
      });

    return orderContactList;
  };

  const findAuthorisedContact = (contacts) => {
    let authorisedContact = contacts.filter((contact) => contact.designation === 'Authorized Signatory')[0];
    if (authorisedContact) {
      return authorisedContact;
    } else {
      return contacts[0];
    }
  };

  // validating accordion on refreeshing the page
  const validateKdmAndGstAccordion = (documents) => {
    const obj = {};
    const authSignDocs = documents?.AUTHORIZED_SIGNATORY;
    authSignDocs &&
      Object.keys(authSignDocs).forEach((item) => {
        if (item !== 'KDM') {
          obj[item] = authSignDocs[item];
        }
      });
    const livePhotoClicked = authSignDocs?.['KDM'];
    const len = Object.keys(obj)?.length;
    const docType = Object.keys(obj)[0]?.split('_')[0];
    if (docType === 'PAN') {
      setKdmAccordionValidation(livePhotoClicked && len === Object.keys(DOC_ARRAY_PAN).length);
      // setIsSaveBtnDisabled(!(livePhotoClicked && len === Object.keys(DOC_ARRAY_PAN).length && Object.keys(documents?.COMPANY).length === Object.keys(DOC_COMPANY_GST).length));
    } else if (docType === 'AADHAAR') {
      setKdmAccordionValidation(livePhotoClicked && len === Object.keys(DOC_ARRAY_AADHAR).length);
      // setIsSaveBtnDisabled(!(livePhotoClicked && len === Object.keys(DOC_ARRAY_AADHAR).length && Object.keys(documents?.COMPANY).length === Object.keys(DOC_COMPANY_GST).length));
    } else if (!docType) {
      setKdmAccordionValidation(false);
      // setIsSaveBtnDisabled(true);
    }
    setCompanyGstValidation(Object.keys(documents?.COMPANY).length === Object.keys(DOC_COMPANY_GST).length);
    // console.log(documents)
    // console.log(livePhotoClicked && len === Object.keys(DOC_ARRAY_PAN).length,Object.keys(documents?.COMPANY).length === Object.keys(DOC_COMPANY_GST).length, "junglee" )
  };

  // console.log("fetchnotcalled")
  const fetchOrderFn = async (setShowEmailPopup = () => {}, order_token = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN), onSuccessCb = () => {}) => {
    try {
      const { res, err } = await fetchOrder(order_token);
      if (res) {
        const {
          data: { success = false, result = {} }
        } = res;

        if (success) {
          onSuccessCb?.(result);
          saveOrder(result);
          setShowLoader(false);
          setOrderDetail(result);
          setUpdatedEmail(result?.lead?.customer?.authorizedSignatory?.email);
          setIsOrderLoaded(true);
          redirectToThankYou({}, result, false);
          showNotificationForSentEmail(result);
          // setShowEmailPopup(true);
          checkOrderConfirmationStatus(result);
          setOrderType(result?.['orderType']);
          setCustomerDetail(result?.['lead']?.['customer']);
          validateKdmAndGstAccordion(result?.documents);
          // console.log(result, "result")
          // if (!isMultiSiteTableEdited) {
          //   setShowEditModal(true);
          // }

          if (isOrderConfirmationUrl()) {
            const partyDetails = {
              partyId: result?.lead?.customer?.partyId,
              partyName: result?.lead?.customer?.authorizedSignatory?.companyName
            };
            setInSessionStorage(MODULE_ID, SELECTED_PARTY_DATA, partyDetails);
          }

          if (result?.['orderType'] === 'CHANGE_ORDER' || (result?.['orderType'] === 'PRE_ORDER' && result?.orderSubType === 'UPGRADE')) {
            setTableRows(ILL_UPGRADE_HEADER_ORDER);
            let customerDetail = result?.['lead']?.['customer'];
            let orderContactDetails = result?.['orderContactDetails'];
            let contactArr = getDefaultContactList(customerDetail['otherContacts']);
            setOrderContactDetails(contactArr);
            let selectedContact = findAuthorisedContact(contactArr);
            let phoneNumberEmpty = selectedContact?.phoneNumber ? false : true;
            let emailEmpty = selectedContact?.email ? false : true;
            if (orderContactDetails) {
              let contactObj = contactArr.filter((contact) => contact.firstName === orderContactDetails['name'])[0];
              let orderContactDetailsPhoneNumberEmpty = () => {
                if (orderContactDetails?.contactNumber) {
                  return orderContactDetails?.contactNumber ? false : true;
                }

                return phoneNumberEmpty;
              };
              let orderContactDetailsEmailEmpty = () => {
                if (orderContactDetails?.emailId) {
                  return orderContactDetails?.emailId ? false : true;
                }

                return emailEmpty;
              };

              setSelectedContact({
                ...contactObj,
                phoneNumber: orderContactDetails?.contactNumber ?? contactObj?.phoneNumber ?? '',
                email: orderContactDetails?.emailId ?? contactObj?.email ?? '',
                phoneNumberEmpty: orderContactDetailsPhoneNumberEmpty(),
                emailEmpty: orderContactDetailsEmailEmpty()
              });
            } else {
              setSelectedContact({
                ...selectedContact,
                phoneNumberEmpty: phoneNumberEmpty,
                emailEmpty: emailEmpty
              });
            }
          }
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);

        isOrderConfirmation ? history.push(ROUTES.B2B_FAILURE) : setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getEstimatedDate = (dateInMs) => {
    return moment(dateInMs).format('DD MMM, YYYY');
  };

  const openUploadDocModal = (locationId = '') => {
    setSelectedLocId(locationId);
    setShowUploadDocModal(true);
  };

  const openViewLineDetailsModal = (rowData = '', fromDocModal = false) => {
    setSelectedRowData(rowData);
    setViewLineDetailsOpeningFromDocModal(fromDocModal);
    setShowViewLineDetailsModal(true);
  };

  const addSiteTypeColumnForVPN = (item, key) => {
    if (isVPN_OR_DI() && item?.lineItemId) {
      return {
        [key]: {
          data: item?.siteType || '-'
        }
      };
    }
    return {};
  };

  const getColumnsValue = (item, sezSiteIdList) => {
    const lastCharcterOfLineItem = `${item?.lineItemId ?? ''}`.charAt(item?.lineItemId?.length - 1);
    const isPrimaryOrSecondarySuffix = ['P', 'S'].includes(lastCharcterOfLineItem);
    let lineItemNumber = (
      <a
        href="javascript:void(0);"
        role="button"
        tabIndex="0"
        className="anchor-style"
        onClick={() => openViewLineDetailsModal(item)}
        title={isPrimaryOrSecondarySuffix ? removeLastString(item.lineItemId) : item.lineItemId}
      >
        {isPrimaryOrSecondarySuffix ? removeLastString(item.lineItemId) : item.lineItemId}
      </a>
    );
    let linkId = (
      <a href="javascript:void(0);" role="button" tabIndex="0" className="anchor-style" onClick={() => openViewLineDetailsModal(item)} title={item.lineItemId}>
        {item?.linkId}
      </a>
    );
    let estimatedDateConv = getEstimatedDate(item.customerNeedDate || item.estimatedDate);
    let gstNumber = item.fiscalCode ? (item.fiscalCode.type === 'GST' ? item.fiscalCode.id : '-') : '-';

    let isSezSite = false;
    if (sezSiteIdList.length > 0) {
      isSezSite = sezSiteIdList.includes(item.lineItemId);
    } else {
      isSezSite = item.fiscalCode && item.fiscalCode.sez;
    }

    let gstDocument = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_CERTIFICATE;
    let loaDocument_1 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_1;
    let loaDocument_2 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_2;
    let loaDocument_3 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_3;

    let loaDocument = !!(loaDocument_1 || loaDocument_2 || loaDocument_3);

    let billingAddress = item.billingAddress
      ? `${item.billingAddress.addressLine1}, ${item.billingAddress.state ? `${item.billingAddress.state},` : ''} ${item.billingAddress.country}`
      : '';

    let installationAddress = item.address ? `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}` : '';

    let shippingAddress = item.shippingAddress
      ? `${item.shippingAddress.addressLine1}, ${item.shippingAddress.state ? `${item.shippingAddress.state},` : ''} ${item.shippingAddress.country}`
      : '';

    let totalPrice = item.planDetail && item.planDetail.price && item.planDetail.price.amount ? item.planDetail.price.amount : 'N/A';
    let ARPPrice = item.planDetail && item.planDetail.price && item.planDetail.price.otc ? item.planDetail.price.otc : 'N/A';

    let siteCotactDetails = {};
    siteCotactDetails['name'] = item?.siteIncharge?.firstName ? item.siteIncharge.firstName : 'N/A';
    siteCotactDetails['phoneNumber'] = item?.siteIncharge?.phoneNumber ? item.siteIncharge.phoneNumber : 'N/A';
    let circuitId = item?.circuitId;
    return {
      lineItemNumber,
      estimatedDateConv,
      gstNumber,
      isSezSite,
      gstDocument,
      loaDocument_1,
      loaDocument_2,
      loaDocument_3,
      loaDocument,
      billingAddress,
      installationAddress,
      shippingAddress,
      totalPrice,
      ARPPrice,
      linkId,
      siteCotactDetails,
      circuitId,
      billingAccountNumber: item?.baId || '',
      planDetail: item?.planDetail || {
        planPeriod: '',
        price: {
          amount: '',
          discount: ''
        }
      }
    };
  };

  const getColumnsForNLDorLL = (item, sezSiteIdList) => {
    const {
      lineItemNumber,
      estimatedDateConv,
      gstNumber,
      isSezSite,
      gstDocument,
      loaDocument,
      billingAddress,
      installationAddress,
      shippingAddress,
      totalPrice,
      ARPPrice,
      linkId
    } = getColumnsValue(item, sezSiteIdList);
    return {
      col1: {
        data: linkId,
        expandRow: true,
        rowSpan: 2,
        subData: isSezSite ? (
          <span className="subvalue">
            <img src={Alert_icon} alt="Alert" /> SEZ Site
          </span>
        ) : null
      },
      col2: {
        data: removeUnderScoreWithSpace(item?.siteType) || '-'
      },
      col3: {
        data: estimatedDateConv || '-'
      },
      col4: {
        data: installationAddress,
        subData: `Branch Code: ${item.branchCode || '-'}`
      },
      col5: {
        data: billingAddress
      },
      col6: {
        data: shippingAddress
      },
      col7: {
        data: gstNumber
      },
      col8: {
        data: (
          <span className="no-wrap cursor-pointer" title="Annual Recurring Cost">
            ARC: &#8377; {totalPrice}
          </span>
        ),
        subData: (
          <span className="no-wrap cursor-pointer" title="One Time Cost">
            OTC: &#8377; {ARPPrice}
          </span>
        )
      },
      col9: {
        data: isSezSite ? (
          <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
            {gstDocument ? 'View Files' : 'Upload Documents'}
          </a>
        ) : (
          '-'
        )
      },
      col10: {
        data: isSezSite ? (
          <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
            {loaDocument ? 'View Files' : 'Upload Documents'}
          </a>
        ) : (
          '-'
        )
      }
    };
  };

  const getColumnsForDI_VPN = (item, sezSiteIdList) => {
    const {
      lineItemNumber,
      estimatedDateConv,
      gstNumber,
      isSezSite,
      gstDocument,
      loaDocument_1,
      loaDocument_2,
      loaDocument_3,
      loaDocument,
      billingAddress,
      installationAddress,
      shippingAddress,
      totalPrice,
      ARPPrice
    } = getColumnsValue(item, sezSiteIdList);
    return {
      col1: {
        data: lineItemNumber,
        subData: isSezSite ? (
          <span className="subvalue">
            <img src={Alert_icon} alt="Alert" /> SEZ Site
          </span>
        ) : null,
        expandRow: item?.dualLastMile,
        rowSpan: isVPN_OR_DI() ? 2 : 0
      },
      col2: {
        data: estimatedDateConv || '-',
        expandRow: item?.dualLastMile,
        rowSpan: isVPN_OR_DI() ? 2 : 0
      },
      col3: {
        data: installationAddress,
        subData: `Branch Code: ${item.branchCode || '-'}`,
        expandRow: item?.dualLastMile,
        rowSpan: isVPN_OR_DI() ? 2 : 0
      },
      col4: {
        data: billingAddress
      },
      col5: {
        data: shippingAddress
      },
      col6: {
        data: gstNumber
      },
      col7: {
        data: (
          <span className="no-wrap cursor-pointer" title="Annual Recurring Cost">
            ARC: &#8377; {totalPrice}
          </span>
        ),
        subData: (
          <span className="no-wrap cursor-pointer" title="One Time Cost">
            OTC: &#8377; {ARPPrice}
          </span>
        )
      },
      col8: {
        data: isSezSite ? (
          <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
            {gstDocument ? 'View Files' : 'Upload Documents'}
          </a>
        ) : (
          '-'
        )
      },
      col9: {
        data: isSezSite ? (
          <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
            {loaDocument ? 'View Files' : 'Upload Documents'}
          </a>
        ) : (
          '-'
        )
      }
    };
  };

  const setTotalPriceColAOI = (item, sezSiteIdList) => {
    const {
      lineItemNumber,
      estimatedDateConv,
      gstNumber,
      isSezSite,
      gstDocument,
      loaDocument_1,
      loaDocument_2,
      loaDocument_3,
      loaDocument,
      billingAddress,
      installationAddress,
      shippingAddress,
      totalPrice,
      ARPPrice,
      billingAccountNumber,
      planDetail
    } = getColumnsValue(item, sezSiteIdList);

    const totalPriceObj = {};
    if (planDetail?.price?.discount) {
      totalPriceObj['data'] = (
        <span className="no-wrap cursor-pointer" title="Annual Recurring Cost">
          Plan:<span style={{ textDecoration: 'line-through' }}>&#8377; {totalPrice}</span>
        </span>
      );
      totalPriceObj['subData'] = (
        <span className="no-wrap cursor-pointer" title="Discount">
          <span className="display-line">Bill value: &#8377; {totalPrice - planDetail?.price?.discount}</span>
          <span style={{}}>
            Discount:<span style={{ color: 'green' }}> &#8377; {planDetail?.price?.discount || '-'}</span>
          </span>
        </span>
      );
    } else {
      totalPriceObj['data'] = <span className="display-line">Bill value: &#8377; {totalPrice - planDetail?.price?.discount}</span>;
    }

    return totalPriceObj;
  };

  const getColumnsForAOI = (item, sezSiteIdList) => {
    // using it for
    const {
      lineItemNumber,
      estimatedDateConv,
      gstNumber,
      isSezSite,
      gstDocument,
      loaDocument_1,
      loaDocument_2,
      loaDocument_3,
      loaDocument,
      billingAddress,
      installationAddress,
      shippingAddress,
      totalPrice,
      ARPPrice,
      billingAccountNumber,
      planDetail
    } = getColumnsValue(item, sezSiteIdList);
    const lastCharcterOfLineItem = `${item?.lineItemId ?? ''}`.charAt(item?.lineItemId?.length - 1);
    const isPrimaryOrSecondarySuffix = ['P', 'S'].includes(lastCharcterOfLineItem);
    // const totalPriceObj = setTotalPriceColAOI();
    // ;
    // console.log(totalPriceObj, "priceObj");
    return {
      // col1: {
      //   data: lineItemNumber,
      //   key: isPrimaryOrSecondarySuffix ? removeLastString(item.lineItemId) : item.lineItemId,
      //   subData: isSezSite ? (
      //     <span className="subvalue">
      //       <img src={Alert_icon} alt="Alert" /> SEZ Site
      //     </span>
      //   ) : null,
      //   expandRow: item?.dualLastMile,
      //   rowSpan: 2
      // },
      // col2: {
      //   data: estimatedDateConv || '-',
      //   expandRow: item?.dualLastMile,
      //   rowSpan: 2
      // },
      col1: {
        data: installationAddress,
        // subData: `Branch Code: ${item.branchCode || '-'}`,
        // subData: `BA Number: ${billingAccountNumber || '-'}`,
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      // ...addSiteTypeColumnForVPN(item, 'col4'),
      // col2: {
      //   data: billingAccountNumber || '-'
      // },
      // col2: {
      //   data: planDetail?.planPeriod/12 || '-'
      // },
      col2: {
        // data: billingAccountNumber || '-'
        data: billingAccountNumber ? (billingAccountNumber === newBA ? '-' : billingAccountNumber) : '-'
      },
      col3: {
        data: planDetail?.price?.discount ? (
          <span className="no-wrap cursor-pointer" title="Annual Recurring Cost">
            Plan:<span style={{ textDecoration: 'line-through' }}>&#8377; {totalPrice}</span>
          </span>
        ) : (
          <span className="display-line">Bill value: &#8377; {totalPrice}</span>
        ),
        subData: planDetail?.price?.discount ? (
          <span className="no-wrap cursor-pointer" title="Discount">
            <span className="display-line">Bill value: &#8377; {totalPrice - planDetail?.price?.discount}</span>
            <span style={{}}>
              Discount:<span style={{ color: 'green' }}> &#8377; {planDetail?.price?.discount || '-'}</span>
            </span>
          </span>
        ) : (
          <></>
        )
      }
      // col3: totalPriceObj
      // col4: {
      //   data: gstNumber,
      //   hide: true
      // },
      // col5: {
      //   data: isSezSite ? (
      //     <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
      //       {gstDocument ? 'View Files' : 'Upload Documents'}
      //     </a>
      //   ) : (
      //     '-'
      //   )
      // },
      // col6: {
      //   data: isSezSite ? (
      //     <a href="javascript:void(0);" role="button" tabIndex="0" onClick={() => openUploadDocModal(item.lineItemId)} style={{ color: '#cc000a' }}>
      //       {loaDocument ? 'View Files' : 'Upload Documents'}
      //     </a>
      //   ) : (
      //     '-'
      //   )
      // }
    };
  };

  const getColumnsForILL_UPGRADE = (item, sezSiteIdList) => {
    const { lineItemNumber, estimatedDateConv, isSezSite, billingAddress, installationAddress, siteCotactDetails, circuitId } = getColumnsValue(item, sezSiteIdList);

    const circuitEle = (
      <a href="javascript:void(0);" role="button" tabIndex={0} className="anchor-style" onClick={() => renderCircuitDetailModal(circuitId)} title={circuitId}>
        {circuitId}
      </a>
    );

    return {
      col1: {
        data: circuitEle || '-'
      },
      col2: {
        data: estimatedDateConv || '-'
      },
      col3: {
        data: installationAddress
        // subData: `Branch Code: ${item.branchCode || '-'}`
      },
      col4: {
        data: billingAddress
      },
      col5: {
        data: siteCotactDetails['name'],
        subData: siteCotactDetails['phoneNumber']
      }
    };
  };

  const renderCircuitDetailModal = async (circuitId) => {
    setShowLoader(true);
    try {
      const { res, err } = await upgradeFetchCircuitDetails(circuitId, true);

      if (res) {
        setShowLoader(false);

        const { data: { success = false, result = {} } = {} } = res;
        if (success) {
          setCircuitModalData(result);
          setShowCircuitDetailModal(true);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

      setShowLoader(false);
      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  };

  const fetchTableData = async (order_token = null, page, size, filterParams, contentData = [], isFilterApplied = filterApplied) => {
    try {
      setShowLoader(true);

      const orderAuthToken = order_token || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      const activePage = page || currentPage - 1;
      const activeDataPerPage = size || (dataPerPageValue && dataPerPageValue.key);

      const { res, err } = await fetchOrderDetails(orderAuthToken, activePage, activeDataPerPage, filterParams ? filterParams : {});
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          setShowLoader(false);
          // setInSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, true);do
          const { totalElement = '', totalPages = '', content = [] } = result;
          setTableData(content);

          const tableColumnsList = [];

          const sezData = sezTableData && sezTableData.content ? sezTableData.content : contentData;

          const sezSiteIdList = isUpgradeJourney() ? [] : Array.isArray(sezData) && sezData.map((item) => item.lineItemId);

          if (isNLD_OR_LL()) {
            setTotalSitesProcessed(Math.floor(totalElement / 2));
          } else {
            setTotalSitesProcessed(totalElement);
          }
          setTotalPages(totalPages);

          const nearest10digitNumber = totalElement > 10 ? Math.ceil(totalElement / 10) * 10 : totalElement;

          const filteredArr = defaultDataPerPageOptions.filter((item) => item.key <= nearest10digitNumber);

          if (filteredArr.length > 0) {
            setDataPerPageOptions(filteredArr);
          } else {
            setDataPerPageOptions(defaultDataPerPageOptions);
          }

          if (!isFilterApplied) {
            totalOrderCount.current = totalElement;

            // dangerouslySetInnerHtml handling for Toast and Notification component
            const getToastMsg = () => {
              const TOAST_MESSAGES = {
                SEZ_INFO: (
                  <div>
                    {editFileMeta['name'] || 'Edit_Order_Summary.xlsx'} updated on the system!
                    <br />
                    All site level details are updated on the system. <br />
                    {sezData.length > 0 &&
                      `Please upload respective GST certificate and Letter of
                      Authorisation against all the <span> ${sezData.length} SEZ sites. </span>`}
                  </div>
                ),
                INFO: (
                  <div>
                    {editFileMeta['name'] || 'Edit_Order_Summary.xlsx'} updated on the system!
                    <br />
                    All site level details are updated on the system. <br />
                  </div>
                )
              };

              if (sezSiteIdList.length > 0) {
                if (isUpgradeJourney()) {
                  return TOAST_MESSAGES.SEZ_INFO;
                }

                return (
                  <div>
                    {editFileMeta['name'] || 'Edit_Order_Summary.xlsx'} updated on the system!
                    <br />
                    All site level details are updated on the system. <br />$
                    {sezData.length > 0 &&
                      `Please upload respective GST certificate and Letter of
                            Authorisation against all the <span> ${sezData.length} SEZ sites. </span>`}
                  </div>
                );
              } else {
                if (isUpgradeJourney()) {
                  return TOAST_MESSAGES.INFO;
                }

                return (
                  <div>
                    {editFileMeta['name'] || 'Edit_Order_Summary.xlsx'} updated on the system!
                    <br />
                    All site level details are updated on the system. <br />
                  </div>
                );
              }
            };

            const toastMsg = getToastMsg();

            isEdit && setToast(true, toastMsg, SUCCESS_TOAST);
            isGSTorLOAupdated && setToast(true, 'SEZ Site required documents updated on the system!', SUCCESS_TOAST);
          }
          let isUpgrade = isUpgradeJourney();
          if (content && content.length > 0) {
            const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
            fetchOrderFn(() => {}, orderAuthToken);
            if (isUpgrade) {
              content.forEach((item) => {
                const columns = getColumnsForILL_UPGRADE(item, sezSiteIdList);
                tableColumnsList.push(columns);
              });
            } else {
              content.forEach((item) => {
                const columns = isNLD_OR_LL() ? getColumnsForNLDorLL(item, sezSiteIdList) : getColumnsForAOI(item, sezSiteIdList);

                tableColumnsList.push(columns);
              });
            }
          }

          setTableColumns(tableColumnsList);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSezOnlyTableData = async (order_token = null) => {
    try {
      setShowLoader(true);
      const orderAuthToken = order_token || getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      const filterParams = {};
      filterParams['sezSites'] = true;

      const { res, err } = await fetchOrderDetails(orderAuthToken, null, null, filterParams ? filterParams : {});
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          const contentData = result && result.content;

          let isSubmitBtnDisabled = false;
          let uploadedDocs = {};
          if (contentData && contentData.length > 0) {
            contentData.forEach(async (item) => {
              let gstFileList = [];
              let loaFileList = [];

              let gstDocument = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_CERTIFICATE;
              let loaDocument_1 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_1;
              let loaDocument_2 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_2;
              let loaDocument_3 = item && item.kycS3DocumentPaths && item.kycS3DocumentPaths.SEZ && item.kycS3DocumentPaths.SEZ.GST_LOA_3;

              let loaDocument = !!(loaDocument_1 || loaDocument_2 || loaDocument_3);

              // if (!gstDocument && !loaDocument) {
              //   isSubmitBtnDisabled = true;
              // }

              let totalLoaDocs = [];

              if (loaDocument_1) {
                totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_1, key: 1 }];
              }
              if (loaDocument_2) {
                totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_2, key: 2 }];
              }
              if (loaDocument_3) {
                totalLoaDocs = [...totalLoaDocs, { fileUrl: loaDocument_3, key: 3 }];
              }

              if (totalLoaDocs.length > 0) {
                totalLoaDocs.forEach(async (fileItem) => {
                  const { fileUrl = '', key = '' } = fileItem;

                  if (fileUrl && key) {
                    const loaFileData = await getFileMeta(fileUrl, key);
                    loaFileList = [...loaFileList, loaFileData];
                    uploadedDocs = {
                      ...uploadedDocs,
                      [item.lineItemId]: {
                        ...uploadedDocs[item.lineItemId],
                        [keyForGSTFiles.GST_LOA]: {
                          files: loaFileList,
                          status: loaFileList.length > 0
                        }
                      }
                    };

                    setUploadedDocStatus(uploadedDocs);
                  }
                });
              } else {
                uploadedDocs = {
                  ...uploadedDocs,
                  [item.lineItemId]: {
                    [keyForGSTFiles.GST_LOA]: {
                      files: [],
                      status: false
                    }
                  }
                };
                setUploadedDocStatus(uploadedDocs);
              }

              if (gstDocument) {
                gstFileList = await getFileMeta(gstDocument);
                uploadedDocs = {
                  ...uploadedDocs,
                  [item.lineItemId]: {
                    ...uploadedDocs[item.lineItemId],
                    [keyForGSTFiles.GST_CERTIFICATE]: {
                      files: gstFileList,
                      status: gstFileList.length > 0
                    }
                  }
                };

                setUploadedDocStatus(uploadedDocs);
              } else {
                uploadedDocs = {
                  ...uploadedDocs,
                  [item.lineItemId]: {
                    [keyForGSTFiles.GST_CERTIFICATE]: {
                      files: [],
                      status: false
                    }
                  }
                };
                setUploadedDocStatus(uploadedDocs);
              }
            });
          }
          setIsSaveBtnDisabled(isUpgradeJourney() ? false : isSubmitBtnDisabled);
          setShowLoader(false);
          setSezTableData(result);
          fetchTableData(order_token, null, null, null, contentData);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onFileUploadCb = (status, type, lineItemId, uploadedFiles) => {
    setIsGSTorLOAupdated(status);
    status && handleClearFilter(false);

    Object.keys(uploadedDocStatus).length > 0 &&
      uploadedDocStatus.hasOwnProperty(lineItemId) &&
      uploadedDocStatus[lineItemId].hasOwnProperty(type) &&
      setUploadedDocStatus((uploadedDocStatus) => ({
        ...uploadedDocStatus,
        [lineItemId]: {
          ...uploadedDocStatus[lineItemId],
          [type]: {
            ...uploadedDocStatus[lineItemId][type],
            files: uploadedFiles,
            status
          }
        }
      }));
  };

  const getFileMeta = async (fileUrl, key = '') => {
    try {
      const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      const { res, err } = await downloadSummaryErrorSheet(fileUrl, orderAuthToken);
      if (res) {
        const { data = {} } = res;
        const fileType = fileUrl && fileUrl.split('.') && fileUrl.split('.')[1];
        const defaultFileName = fileUrl && fileUrl.split('sez/') && fileUrl.split('sez/')[1];

        let fileName = getFileName(res, defaultFileName);
        fileName = key ? `${fileName}@${key}` : fileName;

        const arrayBuffer = new Blob([data], getFileType(fileType));
        const fileObj = new File([arrayBuffer], fileName, getFileType(fileType));
        return [fileObj];
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleEditSubmit = () => {
    fetchSezOnlyTableData();
    setShowEditModal(false);
    toggelToastPopup();
  };

  const checkIfPreOrder = () => {
    return (orderDetail?.orderSubType === 'NEW' || orderDetail?.orderSubType === 'UPGRADE') && orderDetail?.orderType === 'PRE_ORDER';
  };

  const checkIfLoiAvailable = () => {
    return checkIfPreOrder() && !!orderDetail?.lead?.loiAvailable;
  };

  const disableBackButton = () => {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  };

  const redirectToThankYou = (submitOrderRes = {}, orderDetail, isSubmitted = false) => {
    const {
      lead: {
        customer: { partyId, authorizedSignatory },
        lineItemCount = ''
      },
      orderId,
      orderStatus
    } = orderDetail;

    let redirectUrl = ROUTES.DEDICATED_THANK_YOU;

    // if (orderDetail.lead.customer.partyId) {
    //   redirectUrl = redirectUrl + '?partyId=' + partyId;
    // }

    if (isDevEnv() && isAuthForDev()) {
      redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
    }

    if (isOrderSubmittedByCustomer(orderStatus) || isSubmitted) {
      history.push(redirectUrl, {
        leadId: orderId,
        userType: authorizedSignatory.contactType,
        hideNetworkSteps: true,
        via: 'SUMMARY',
        isMultiSite: true,
        isThankYouAuth: true,
        noOfCircuits: lineItemCount,
        isUpgrade: isUpgradeJourney() ? true : false,
        dateStamp: (submitOrderRes && submitOrderRes.submittedAt) || '',
        product: getProductType()
      });
    } else if (orderStatus === ORDER_TYPE.ORDER_CANCELLED) {
      toggelToastPopup();
      let redirectUrlCancel = ROUTES.DEDICATED_CANCEL;
      if (orderDetail.lead.customer.partyId) {
        redirectUrlCancel = redirectUrl + '?partyId=' + partyId;
      }
      history.push(redirectUrlCancel, {
        leadId: orderId,
        orderId: orderId,
        userType: authorizedSignatory.contactType,
        hideNetworkSteps: true,
        via: 'SUMMARY',
        isMultiSite: true,
        isThankYouAuth: true,
        noOfCircuits: lineItemCount,
        isUpgrade: isUpgradeJourney() ? true : false,
        dateStamp: (submitOrderRes && submitOrderRes.submittedAt) || '',
        product: getProductType()
      });
    }
  };

  const submitOrder = async () => {
    try {
      setShowLoader(true);
      const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

      const { res, err } = await submitOrderForSummary(orderAuthToken);
      if (res) {
        // const { data: { success = false, result = {} } = {} } = res;

        if (res && res.data && res.data.success) {
          setShowLoader(false);
          setOtpVerifyLoader(false);
          // setOpacityClass('')
          redirectToThankYou(res.data.result, orderDetail, true);
        } else {
          setShowLoader(false);
          setOtpVerifyLoader(false);
          // setOpacityClass('')
          showServiceError({
            show: true,
            data: GENERIC_ERROR_MESSAGE,
            redirect: false
          });
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;

        setShowLoader(false);
        setOtpVerifyLoader(false);
        // setOpacityClass('')
        showServiceError({
          show: true,
          data: errorMsg,
          redirect: false
        });
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;

      setShowLoader(false);
      setOtpVerifyLoader(false);
      // setOpacityClass('')
      showServiceError({
        show: true,
        data: errorMsg,
        redirect: false
      });
      throw new Error(errorMsg);
    }
  };

  const checkHasKeyTouched = (objParam) => {
    let isTouched = false;
    if (objParam) {
      for (let item in objParam) {
        let value = objParam[item];
        if (value && Object.prototype.toString.call(value) === '[object Object]' && value.hasOwnProperty('touched') && value['touched']) {
          isTouched = true;
          break;
        }
      }
    }

    return isTouched;
  };

  const updateOrder = async (form = null, isPurchaseForm = false, isPOChecked = false, isLoiForm = false) => {
    if (orderDetail && ![ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING, ORDER_TYPE.ORDER_CANCELLED].includes(orderDetail.orderStatus)) {
      try {
        setShowLoader(true);
        let anyFieldTouched = false;

        for (let item in formData) {
          anyFieldTouched = checkHasKeyTouched(formData[item]);
        }

        const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

        let updatedFormData = { ...formData };
        if (form?.address?.value) {
          form = { ...form, address: { value: removeAsciiCode(form?.address?.value) } };
        }
        if (form) {
          if (isLoiForm) {
            updatedFormData = {
              ...updatedFormData,
              loiDetail: form
            };
          } else if (isPurchaseForm) {
            updatedFormData = {
              ...updatedFormData,
              purchaseDetail: form
            };
          } else {
            updatedFormData = {
              ...updatedFormData,
              billingDetails: form
            };
          }
        }

        const orderRequest = getRequestForOrderUpdate({ ...updatedFormData }, orderDetail, isPurchaseForm, isPOChecked, customerAccounts, isLoiForm);

        const { res, err } = await updateOrderForSummary(orderRequest, orderAuthToken);
        if (res) {
          const { data: { success = false, result = {} } = {} } = res;

          if (success) {
            setShowLoader(false);
          }
        } else if (err) {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

          setShowLoader(false);
          setToast(true, errorMsg, ERROR_TOAST);
          throw new Error(errorMsg);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const updateParentForm = (updatedForm) => {
    setFormData((prevState) => {
      return { ...prevState, ...updatedForm };
    });
  };

  const updateFormStatus = (formStatus) => {
    setFormStatus((prevState) => {
      return { ...prevState, ...formStatus };
    });
  };

  const isFormValid = () => {
    if (isUpgradeJourney()) {
      // return formStatus.purchaseDetail && isMultiSiteTableEdited;
      return isMultiSiteTableEdited;
    }

    if (isPreOrder() || checkIfPreOrder()) {
      if (isLoiAvailable() || checkIfLoiAvailable()) {
        return formStatus.billingDetails && formStatus.loiDetail && (isMultiSiteTableEdited || isOrderConfirmation);
      } else {
        return formStatus.billingDetails && (isMultiSiteTableEdited || isOrderConfirmation);
      }
    }

    // return formStatus.billingDetails && formStatus.purchaseDetail && (isMultiSiteTableEdited || isOrderConfirmation);
    // return formStatus.purchaseDetail && (isMultiSiteTableEdited || isOrderConfirmation);
    return isMultiSiteTableEdited || isOrderConfirmation;
  };

  const handleUploadDocModalSubmit = () => {
    fetchSezOnlyTableData();
    setShowUploadDocModal(false);
    toggelToastPopup();
  };

  const handleClearFilter = (reload = true) => {
    setFiltersApplied(false);
    setSearchType('');
    setSearchValue('');
    setFilterValue(defaultFilterOptions[0]);

    if (reload) fetchTableData(null, null, null, null, [], false);
  };

  const getSortValue = (value) => {
    if (value === 'ascending') {
      return 'descending';
    }
    if (value === 'descending') {
      return 'ascending';
    }

    return 'descending';
  };

  const handleSortClick = (key, value) => {
    const updatedRows = tableRows.map((item) => {
      if (item.sortKey === key) {
        item.sortValue = getSortValue(value);
      }
      return item;
    });

    const multiSortArrCpy = [...multiSortArr];

    const hasSortKey = multiSortArrCpy.some((item) => item.key === key);

    if (hasSortKey) {
      multiSortArrCpy.map((item) => {
        if (item.key === key) {
          item.value = getSortValue(value) === 'ascending' ? true : false;
        }

        return item;
      });
    } else {
      multiSortArrCpy.push({
        key,
        value: getSortValue(value) === 'ascending' ? true : false
      });
    }

    setFiltersApplied(true);
    setTableRows(updatedRows);
    setMultiSortArr(multiSortArrCpy);
  };

  const handleFileUpload = (uploadedFiles, isFileUploaded) => {
    if (isFileUploaded) {
      handleClearFilter(false);
      setInSessionStorage(MULTI_SITE_MODULE_ID, MULTI_SITE_TABLE_EDITED, isFileUploaded);
    }
    setIsEdit(isFileUploaded);
    setEditFileMeta(uploadedFiles[0]);
  };

  const updateOrderContactDetails = async (orderRequest, orderAuthToken) => {
    try {
      const { res, err } = await updateOrderForSummary({ orderContactDetails: { ...orderRequest } }, orderAuthToken);
      if (res) {
        const { data: { success = false, result = {} } = {} } = res;

        if (success) {
          setShowLoader(false);
        }
      } else if (err) {
        handleError(err);
      }
    } catch (err) {
      handleError(err);
    }
  };

  const handleError = (err) => {
    const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
    setShowLoader(false);
    setToast(true, errorMsg, ERROR_TOAST);
    throw new Error(errorMsg);
  };

  const downloadSites = () => {
    handleDownloadClick();
  };

  const handleDownloadClick = async () => {
    try {
      const { res, err } = await getDownloadApi();
      if (res) {
        const { data = {} } = res;
        const fileName = getFileName(res, getFileDefaultName());
        downloadFileURI(data, fileName);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onSendQuoteClick = async () => {
    try {
      const request = { email: [orderDetail?.lead?.customer?.customerEmail] };
      const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
      const { res, err } = await sendQuotationAOI(request, orderAuthToken);
      if (res) {
        const message = res?.data?.result;
        setToast(true, message || 'Quote sent successfully.', SUCCESS_TOAST);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onSendPhotoLink = async () => {
    try {
      const request = {};
      const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
      const { res, err } = await sendPhotoLinkAOI(request, orderAuthToken);
      if (res) {
        const message = res?.data?.result;
        setToast(true, message || 'Link sent successfully to your email.', SUCCESS_TOAST);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getDownloadApi = () => {
    const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

    const orderId = getFromSessionStorage(MULTI_SITE_MODULE_ID, ORDER_ID);

    return orderBulkDownload(orderId, orderAuthToken, isdedicatedJourney);
  };

  const getFileDefaultName = () => {
    return 'Edit_Order_Summary_Upload_DI.xlsx';
  };

  const disableAddressDetailsAccordion = (order) => {
    // bassed on if data present in order we will disable it
    const billingAddressAOI = order?.billingAddress;
    const defaultPinCode = billingAddressAOI?.pincode;
    const defaultCity = billingAddressAOI?.city;
    const defaultAddress = billingAddressAOI?.addressLine1;
    if (defaultPinCode && defaultCity && defaultAddress) {
      setAddressDetailsAccordion(true);
    }
  };

  const setMetaTags = () => {
    let title = document.querySelector('title');
    title.innerHTML = 'Business Broadband - Airtel Office Internet Plans';
  };

  useEffect(() => {
    setMetaTags();
  }, []);

  useEffect(() => {
    // disableAddressDetailsAccordion(orderDetail);
  }, []);

  // console.log(kdmAccordionValidation, companyGstValidation, "validation", isSaveBtnDisabled)

  return (
    <section className="order_summary_for">
      {otpVerifyLoader && (
        <div className="loader-otp-verify">
          <RoundLoader />
        </div>
      )}
      <div>
        {showUploadDocModal && (
          <UploadDocModal
            isOpen={showUploadDocModal}
            setIsOpen={setShowUploadDocModal}
            title="Upload Documents for SEZ Sites"
            onSaveClick={handleUploadDocModalSubmit}
            onCancelCb={fetchSezOnlyTableData}
            selectedLocId={selectedLocId}
            sezTableData={sezTableData}
            openViewLineDetailsModal={openViewLineDetailsModal}
            setToast={setToast}
            toast={toast}
            uploadedDocStatus={uploadedDocStatus}
            onFileUploadCb={onFileUploadCb}
            isOrderConfirmation={isOrderConfirmation}
          />
        )}
        {showViewLineDetailsModal && (
          <ViewLineDetailsModal
            isOpen={showViewLineDetailsModal}
            setIsOpen={setShowViewLineDetailsModal}
            title={`${isNLD_OR_LL() ? 'Link ID:' : 'Location ID:'} ${selectedRowData.lineItemId}`}
            selectedRowData={selectedRowData}
            formData={formData}
            openUploadDocModal={openUploadDocModal}
            viewLineDetailsOpeningFromDocModal={viewLineDetailsOpeningFromDocModal}
            allRecords={tableData}
          />
        )}

        {showCanceLeadPopup && <CancelOrderPopup isSummaryPage isCustomerCancel setshowPopup={setShowCancelLeadPopup} metaData={orderDetail}></CancelOrderPopup>}
        {showEditModal && (
          <DrawerModalComponent
            isOpen={showEditModal}
            setIsOpen={setShowEditModal}
            title="Edit Sites with Excel"
            onSaveClick={handleEditSubmit}
            downloadHeading="Export Excel Edit File"
            downloadSubHeading={isUpgradeJourney() ? getDownloadModalTextForUpgrade() : getDownloadModalTextForSummary()}
            downloadBtnName="Download Excel For Edit"
            toast={toast}
            setToast={setToast}
            currentPage={FILE_UPLOAD_PAGES.ORDER_SUMMARY}
            onDrawerUploadCb={handleFileUpload}
            {...props}
          />
        )}
        <div className="row">
          <div className="flg-lg-9 flg-md-12">
            {/* <h5 className="b2b-lib-accordionContainer header-name">Review and Submit Order</h5> */}
            {isOrderLoaded && (
              <React.Fragment>
                {/* {isLoiAvailable() || checkIfLoiAvailable() ? (
                <LoiDetails
                  order={orderDetail}
                  updateParentForm={updateParentForm}
                  setFormStatus={updateFormStatus}
                  updateOrder={updateOrder}
                  setToast={setToast}
                  isOrderConfirmation={isOrderConfirmation}
                />
              ) : isPreOrder() || checkIfPreOrder() ? null : ( */}
                {showAoiKycStep ? (
                  <React.Fragment>
                    <div style={{ marginBottom: '20px', marginTop: '-20px' }}>
                      <KdmDetails
                        order={orderDetail}
                        fetchOrderFn={fetchOrderFn}
                        setIsSaveBtnDisabled={setIsSaveBtnDisabled}
                        updatedEmail={updatedEmail}
                        setUpdatedEmail={setUpdatedEmail}
                        kdmAccordionValidation={kdmAccordionValidation}
                        setKdmAccordionValidation={setKdmAccordionValidation}
                        companyGstValidation={companyGstValidation}
                      />
                    </div>
                    <div>
                      <CompanyGstDocuments
                        order={orderDetail}
                        fetchOrderFn={fetchOrderFn}
                        setIsSaveBtnDisabled={setIsSaveBtnDisabled}
                        updatedEmail={updatedEmail}
                        setUpdatedEmail={setUpdatedEmail}
                        companyGstValidation={companyGstValidation}
                        setCompanyGstValidation={setCompanyGstValidation}
                        kdmAccordionValidation={kdmAccordionValidation}
                      />
                    </div>
                    {orderDetail?.eligibleForBilling && (
                      <AddressDetailsAOI
                        order={orderDetail}
                        formAdd={formAdd}
                        setformAdd={setFormAdd}
                        accordionMetadataAddress={accordionMetadataAddress}
                        setAccordionMetadataAddress={setAccordionMetadataAddress}
                      />
                    )}
                    {/* <AddressDetailsAOI /> */}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <AddressProcess
                      parentClassname={!isMultiSiteTableEdited ? 'no_kyc_data' : ''}
                      showProcessComponent
                      showFilterOptions={false}
                      // showTableData={isMultiSiteTableEdited || isOrderConfirmation}
                      // showFileName={isEdit}
                      showFileName={false}
                      fileData={editFileMeta}
                      showSubHeader={false}
                      showSearchFilterOptions={false}
                      processIdLabel={isUpgradeJourney() ? 'Order Request ID :' : null}
                      processId={isUpgradeJourney() ? orderDetail?.lead?.leadId : null}
                      processSiteLabel={isAOIOrder ? ' Sites in Order' : isNLD_OR_LL() ? 'Total Links' : 'Total Feasible Sites'}
                      processSiteProcessed={totalSitesProcessed}
                      onProcessBtnClick={() => setShowEditModal(true)}
                      processBtnName={isAOIOrder() ? 'Select Plan with Excel' : isUpgradeJourney() ? 'Edit with Excel' : 'Configure with Excel'}
                      filterLabel="SEZ Sites"
                      filterValue={filterValue}
                      filterOptions={defaultFilterOptions}
                      filterOnChange={(value) => {
                        setFiltersApplied(true);
                        setFilterValue(value);
                      }}
                      searchType={searchType}
                      onSearchTypeChange={(type) => {
                        setFiltersApplied(false);
                        setSearchType(type);
                        setSearchValue('');
                      }}
                      searchValue={searchValue}
                      onSearchValueChange={(value) => {
                        setFiltersApplied(true);
                        setSearchValue(value);
                      }}
                      searchTypeOptions={isNLD_OR_LL() ? SEARCH_OTIONS_NLD_LL : isUpgradeJourney() ? SEARCH_OTIONS_ILL_UPGRADE : SEARCH_OTIONS_DI_VPN}
                      onSearchClick={() => {
                        let filterParams = {};

                        if (searchType && searchValue) {
                          filterParams[searchType['key']] = searchValue;
                        }
                        fetchTableData(null, null, null, filterParams, []);
                      }}
                      onClearFilter={handleClearFilter}
                      rows={tableRows}
                      cols={tableColumns}
                      dataPerPageValue={dataPerPageValue}
                      dataPerPageOptions={dataPerPageOptions}
                      dataPerPageOnChange={(val) => {
                        setFiltersApplied(true);
                        setDataPerPageValue(val);
                      }}
                      currentPage={currentPage}
                      onPageSelect={(pageNo) => {
                        setFiltersApplied(true);
                        setShowLoader(true);
                        setCurrentPage(pageNo);
                      }}
                      totalPages={totalPages}
                      onSortClick={handleSortClick}
                      filterApplied={filterApplied}
                      showLoader={showLoader}
                      showEditExcelButtonLoader={isOrderConfirmation}
                      isRowSpanEnabled={(isNLD_OR_LL() || isVPN_OR_DI()) && !isBulkUpgrade()}
                    />
                    <PurchaseDetails
                      order={orderDetail}
                      updateParentForm={updateParentForm}
                      setFormStatus={updateFormStatus}
                      updateOrder={updateOrder}
                      setToast={setToast}
                      isOrderConfirmation={isOrderConfirmation}
                    />
                  </React.Fragment>
                )}
                <FooterComponent
                  order={orderDetail}
                  isFormValid={isFormValid()}
                  submitOrder={submitOrder}
                  updateOrder={updateOrder}
                  isSaveBtnDisabled={isSaveBtnDisabled}
                  formAdd={formAdd}
                  addressAccordionValidator={accordionMetadataAddress}
                  setIsSaveBtnDisabled={setIsSaveBtnDisabled}
                  totalSites={filterApplied ? totalOrderCount.current : totalSitesProcessed}
                  isOrderConfirmation={isOrderConfirmation}
                  setNotification={setNotification}
                  fetchOrder={fetchOrderFn}
                  showEmailPopup={showEmailPopup}
                  orderConfirmationPopup={orderConfirmationPopup}
                  setShowEmailPopup={setShowEmailPopup}
                  setOrderConfirmationPopup={setOrderConfirmationPopup}
                  isUpgrade={isUpgradeJourney()}
                  customerDetail={customerDetail}
                  setCustomerDetail={setCustomerDetail}
                  showLoader={showLoader}
                  showAoiKycStep={showAoiKycStep}
                  setShowAoiKycStep={setShowAoiKycStep}
                  updatedEmail={updatedEmail}
                  otpVerifyLoader={otpVerifyLoader}
                  setOtpVerifyLoader={setOtpVerifyLoader}
                  setOpacityClass={setOpacityClass}
                ></FooterComponent>
              </React.Fragment>
            )}
          </div>
          <div className="flg-lg-3 flg-md-12">
            <div className="row">
              {isOrderLoaded && (
                <div className="flg-lg-12 flg-md-12">
                  {/* <ActionCall order={orderDetail} /> */}
                  <PlanSummaryCard order={orderDetail} downloadSites={downloadSites} />
                </div>
              )}
            </div>
          </div>
        </div>
        {Object.keys(orderDetail).length > 1 && orderDetail?.orderStatus === 'OV_REJECTED' && (
          <OvRejection setNotification={setNotification} orderDetail={orderDetail}></OvRejection>
        )}
      </div>
    </section>
  );
}
export default DedicatedOrderSummaryAOI;
